<template>
  <v-container>
    <v-card>
      <v-card-title>🌍 Mapa Mundial Estático</v-card-title>
      <v-card-text>
        <div id="map" style="height: 500px;"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// Corregir rutas de los íconos
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  name: 'MapaMundial',
  data() {
    return {
      mapa: null,
      ubicaciones: [
        {
          latitude: 37.42240,
          longitude: -122.08421,
          city: "Mountain View",
          country: "United States"
        },
        {
          latitude: -25.2820,
          longitude: -57.6350,
          city: "Asunción",
          country: "Paraguay"
        },
        {
          latitude: 51.5074,
          longitude: -0.1278,
          city: "London",
          country: "United Kingdom"
        }
      ]
    }
  },
  mounted() {
    this.initMapa()
    this.marcarUbicaciones()
  },
  methods: {
    initMapa() {
      this.mapa = L.map('map', {
        zoomControl: false,        // sin controles de zoom
        dragging: false,           // no permitir arrastrar
        scrollWheelZoom: false,    // no permitir zoom con rueda del mouse
        doubleClickZoom: false,    // no permitir zoom con doble clic
        boxZoom: false,
        keyboard: false,
        touchZoom: false,          // no permitir zoom con gestos táctiles
        tap: false
      })

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
      }).addTo(this.mapa)
    },
    marcarUbicaciones() {
      const bounds = []

      this.ubicaciones.forEach(ubicacion => {
        const latLng = [ubicacion.latitude, ubicacion.longitude]
        bounds.push(latLng)
        L.marker(latLng).addTo(this.mapa)
      })

      if (bounds.length > 0) {
        this.mapa.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 2 // evita que se acerque demasiado
        })
      }
    }
  }
}
</script>

<style scoped>
#map {
  height: 500px;
  width: 100%;
  z-index: 0;
}
</style>
